import React, { useState, useRef, useEffect } from "react"
import { useSelector } from "react-redux"
import {
    StepController,
    Step,
    Modal,
    ModalTitle,
    TitleSection,
    ContentSection,
    FooterSection,
    Label,
    Button,
    Row,
    Column,
    Color,
    Element,
    Icon,
    Input,
} from "trux"
import { useHistory } from "react-router-dom"
import { DetailsForm } from "./RosterInvite/DetailsForm"
import { addRelation, loadPlayerRelations, addAllRelations } from "./actions"
import { validatePhone, validateEmail } from "../../util/helpers"

export const InviteFamilyMemberModal = (props) => {
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [number, setNumber] = useState("")
    const [errors, setErrors] = useState({
        name: null,
        email: null,
        phone: null,
        ready: true,
    })
    const [step, setStep] = useState("WhichPlayer")
    const family = useSelector((state) => state.family.value)
    const players = family.filter(function (el) {
        return el.relation === "child"
    })
    //console.log("family", family, result)
    const [selected, setSelected] = useState([])
    const [selectedUserIds, setSelectedUserIds] = useState([])
    const history = useHistory()

    const [showCinnamonToast, setShowCinnamonToast] = useState(false)
    const cinnamonToastTimeout = useRef(null)

    const handleCloseButtonClick = (e) => {
        e.preventDefault()
        history.goBack()
    }

    const onButtonClick = (buttonId) => {
        console.log("buttonid", buttonId)
        if (!selected.includes(buttonId)) {
            setSelected((current) => [...current, buttonId])
            setSelectedUserIds((current) => [...current, buttonId.user_id])
            console.log("selected", selected)
        } else {
            setSelected((current) =>
                current.filter((button) => button !== buttonId)
            )
        }
    }

    const validate = () => {
        var nameError = null
        var emailError = null
        var phoneError = null
        var ready = true

        if (name.length === 0) {
            nameError = "A family member must have a name"
        }

        if (email.length === 0) {
            emailError = "A family member must have an email"
        } else if (!validateEmail(email)) {
            emailError = "Invalid email"
        }

        if (number.length != 0 && !validatePhone(number)) {
            phoneError = "Invalid phone number"
        }

        if (nameError || emailError || phoneError) {
            ready = false
        }

        setErrors({
            name: nameError,
            email: emailError,
            phone: phoneError,
            ready: ready,
        })

        return ready
    }

    const onContinue = () => {
        if (validate()) {
            setShowCinnamonToast(true)
            addAllRelations(selectedUserIds, {
                first_name: name,
                email: email,
                relation: "child",
            })
            cinnamonToastTimeout.current = setTimeout(() => {
                console.log("GamePage toast timeout")
                setShowCinnamonToast(false)
                history.goBack()
                if (props.match.params) {
                    setTimeout(() => {
                        window.location.reload(true)
                    }, 200)
                }
            }, 1500)
            //props.onDone()
        }
    }

    return (
        <Modal
            className="RemoveFamily"
            open
            onShadeClick={(e) => {
                handleCloseButtonClick(e)
            }}
        >
            <StepController step={step}>
                <Step name="WhichPlayer">
                    <TitleSection onCloseClick={handleCloseButtonClick}>
                        <ModalTitle content={"Which players?"} />
                    </TitleSection>
                    <ContentSection>
                        <Column center>
                            <Label
                                center
                                type={Label.Type.Body}
                                color={Color.Charcoal40}
                                marginBottom="4"
                                content="Select which players you would like to add a family member for."
                            />
                            <Row>
                                {players.map((player) => (
                                    <Element
                                        key={player.user_id}
                                        className={`big-button ${
                                            selected.includes(player.user)
                                                ? "selected"
                                                : ""
                                        }`}
                                        onClick={() =>
                                            onButtonClick(player.user)
                                        }
                                    >
                                        <Element className="contents">
                                            {selected.includes(player.user) && (
                                                <Element className="selected-check">
                                                    <Icon
                                                        size={16}
                                                        type={Icon.Type.Check}
                                                    />
                                                </Element>
                                            )}
                                            <Label
                                                width="128px"
                                                content={player.user.first_name}
                                            />
                                        </Element>
                                    </Element>
                                ))}
                            </Row>
                        </Column>
                    </ContentSection>
                    <FooterSection>
                        <Button
                            className="button"
                            content="Continue"
                            onClick={(e) => setStep("FamilyMemberDetails")}
                        />
                    </FooterSection>
                </Step>
                <Step name="FamilyMemberDetails">
                    <TitleSection onCloseClick={handleCloseButtonClick}>
                        <ModalTitle content={"Family member details?"} />
                    </TitleSection>
                    <ContentSection>
                        <Label
                            center
                            type={Label.Type.Body}
                            color={Color.Charcoal40}
                            marginBottom="4"
                            content="Provide the contact details for the family member you would like to invite."
                        />
                        <Row center>
                            <Label
                                center
                                type={Label.Type.Body}
                                color={Color.Charcoal40}
                                content="Selected players:"
                                marginRight="1"
                            />{" "}
                            <Label
                                center
                                type={Label.Type.Body}
                                color={Color.Charcoal40}
                                bold
                                marginBottom="4"
                                content={selected
                                    .map(function (elem) {
                                        return elem.first_name
                                    })
                                    .join(", ")}
                            />
                        </Row>

                        <Column center span="12" className="form">
                            <Input
                                type={Input.Type.Name}
                                label={
                                    <Row>
                                        <Label
                                            type={Label.Type.SmallBody}
                                            content="Full name"
                                            marginRight="1"
                                        />{" "}
                                        <Label
                                            type={Label.Type.SmallBody}
                                            content="*"
                                            color={Color.Error}
                                        />
                                    </Row>
                                }
                                value={name}
                                onChange={(e) => setName(e)}
                                error={errors.name}
                            />
                            <Input
                                type={Input.Type.Email}
                                label={
                                    <Row>
                                        <Label
                                            type={Label.Type.SmallBody}
                                            content="Email"
                                            marginRight="1"
                                        />{" "}
                                        <Label
                                            type={Label.Type.SmallBody}
                                            content="*"
                                            color={Color.Error}
                                        />
                                    </Row>
                                }
                                value={email}
                                onChange={(e) => setEmail(e)}
                                error={errors.email}
                            />
                            <Input
                                type={Input.Type.Text}
                                label={
                                    <Label
                                        type={Label.Type.SmallBody}
                                        content="Phone"
                                    />
                                }
                                value={number}
                                onChange={(e) => setNumber(e)}
                                error={errors.phone}
                                marginBottom="7"
                            />
                        </Column>
                        {showCinnamonToast && (
                            <Element className="cinnamon-toast">
                                <Element className="cinnamon-toast-window">
                                    <Column span="12" center>
                                        <Icon
                                            type={Icon.Type.Check}
                                            color={Color.White}
                                        />
                                        <Label color={Color.White}>
                                            Invite sent
                                        </Label>
                                    </Column>
                                </Element>
                            </Element>
                        )}
                    </ContentSection>
                    <FooterSection>
                        <Button
                            className="button"
                            content="Send invite"
                            onClick={onContinue}
                        />
                    </FooterSection>
                </Step>
            </StepController>
        </Modal>
    )
}
